import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LmoBannedDriver, LmoDriver, LmoDriverService } from '~services/lmo-driver.service';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, pluck } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { BanDriverDialogComponent } from '../ban-driver-dialog/ban-driver-dialog.component';
import { ReinstateDriverDialogComponent } from '../reinstate-driver-dialog/reinstate-driver-dialog.component';

@Component({
  selector: 'sa-lmo-banned-driver-list',
  templateUrl: './lmo-banned-driver-list.component.html',
  styleUrls: ['./lmo-banned-driver-list.component.scss'],
})
export class LmoBannedDriverListComponent implements OnInit, OnDestroy {
  public drivers$: Observable<LmoBannedDriver[]>;
  public pageSize$: Observable<number>;
  public page$: Observable<number>;
  public total$: Observable<number>;

  public driverSearchControl = new FormControl();

  private subs: Subscription[] = [];

  constructor(private lmoDriverService: LmoDriverService, private matDialog: MatDialog) {
    this.drivers$ = this.lmoDriverService.lmoBannedDriversPage$.pipe(pluck('drivers'));
    this.pageSize$ = this.lmoDriverService.lmoBannedDriversPage$.pipe(pluck('pageSize'));
    this.page$ = this.lmoDriverService.lmoBannedDriversPage$.pipe(pluck('pageNumber'));
    this.total$ = this.lmoDriverService.lmoBannedDriversPage$.pipe(pluck('total'));
  }

  public ngOnInit(): void {
    this.lmoDriverService.getLmoBannedDrivers();

    if (this.lmoDriverService.searchbarValue$$.getValue().searchBanDriver) {
      this.driverSearchControl.patchValue(this.lmoDriverService.searchbarValue$$.getValue().searchBanDriver);
    }

    this.subs.push(
      this.driverSearchControl.valueChanges.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((search) => {
        this.lmoDriverService.setLmoBannedDriversSearch(search);
        const currentSeachbarValue = this.lmoDriverService.searchbarValue$$.getValue();
        this.lmoDriverService.searchbarValue$$.next({
          ...currentSeachbarValue,
          searchBanDriver: search,
        });
      }),
    );
  }

  public ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  public sortChanged(sortParams) {
    if (sortParams.active && sortParams.direction) {
      this.lmoDriverService.setLmoBannedDriversSort(sortParams.active, sortParams.direction);
    } else {
      this.lmoDriverService.setLmoBannedDriversSort(null, null);
    }
  }

  public switchPage(page: PageEvent) {
    this.lmoDriverService.setLmoBannedDriversPage(page.pageIndex + 1, page.pageSize);
  }

  public promptReinstateDriver(driver: LmoBannedDriver) {
    this.matDialog.open(ReinstateDriverDialogComponent, {
      data: { driver },
    });
  }
}
